var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUtilityCheckMark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Components/Desktop/Recommended-For-2",
    stroke: "#63a3f0",
    strokeWidth: 4,
    transform: "translate(-824 -230)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bullets",
    transform: "translate(62 221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    d: "M0 6.473 6.396 14 14 0",
    transform: "translate(0 11)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUtilityCheckMark);
export default __webpack_public_path__ + "static/media/icon-utility-check-mark.4180a25088b56ce7deadf1eeed7517f0.svg";
export { ForwardRef as ReactComponent };